var _filter, _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIconInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 47,
    viewBox: "0 0 64 47",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 46.9811,
    width: 62.4276,
    x: 0.786195,
    y: 0
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.76726
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.1069
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0196802 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_1180_5117"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1180_5117",
    mode: "normal",
    result: "shape"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 40,
    rx: 8,
    width: 56,
    x: 4,
    y: 1
  }), /*#__PURE__*/React.createElement("rect", {
    height: 41,
    rx: 8.5,
    stroke: "#e9e9e9",
    width: 57,
    x: 3.5,
    y: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m36.375 15.75h-.8749v-1.75h-1.7501v1.75h-3.5v-1.75h-1.7501v1.75h-.8749c-.6963 0-1.3638.2765-1.8561.7688-.4924.4924-.7689 1.1599-.7689 1.8562v7c0 .6963.2765 1.3639.7689 1.8561.4923.4924 1.1598.7689 1.8561.7689h8.75c.6962 0 1.3638-.2765 1.8561-.7689.4924-.4922.7689-1.1598.7689-1.8561v-7c0-.6962-.2765-1.3638-.7689-1.8562-.4923-.4923-1.1598-.7688-1.8561-.7688zm.8749 9.625c0 .2321-.0921.4546-.2562.6188-.1642.164-.3866.2562-.6187.2562h-8.75c-.2321 0-.4546-.0922-.6188-.2562-.164-.1642-.2562-.3867-.2562-.6188v-.8749h10.5zm0-2.6249h-10.5v-4.375c0-.2321.0922-.4547.2562-.6188.1642-.164.3867-.2563.6188-.2563h.8749v1.75h1.75v-1.75h3.5001v1.75h1.75v-1.75h.875c.2321 0 .4545.0923.6187.2563.164.1641.2562.3867.2562.6188z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m35.3001 15.95v-1.75h-1.3501v1.75h-3.9v-1.75h-1.3501v1.75h-1.0749c-.6432 0-1.2599.2555-1.7147.7102-.4549.4549-.7103 1.0716-.7103 1.7148v7c0 .6433.2554 1.2599.7103 1.7147.4548.4548 1.0715.7103 1.7147.7103h8.75c.6432 0 1.2599-.2554 1.7146-.7103.4549-.4547.7104-1.0714.7104-1.7147v-7c0-.6432-.2554-1.2599-.7103-1.7148-.4548-.4547-1.0714-.7102-1.7147-.7102zm-6.8002-1.95h1.7501v1.75h3.5v-1.75h1.7501v1.75h.8749c.6963 0 1.3638.2765 1.8561.7688.4924.4924.7689 1.16.7689 1.8562v7c0 .6963-.2765 1.3639-.7689 1.8561-.4923.4924-1.1599.7689-1.8561.7689h-8.75c-.6963 0-1.3638-.2765-1.8561-.7689-.4924-.4922-.7689-1.1598-.7689-1.8561v-7c0-.6963.2765-1.3638.7689-1.8562.4923-.4923 1.1598-.7688 1.8561-.7688h.8749zm8.75 11.375c0 .2321-.0921.4546-.2562.6188-.1642.164-.3866.2562-.6187.2562h-8.75c-.2321 0-.4546-.0922-.6188-.2562-.164-.1642-.2562-.3867-.2562-.6188v-.8749h10.5zm.2 0 .0002-1.0749h-10.9001v1.0749c0 .2852.1133.5585.3147.7601.2017.2015.4751.3149.7603.3149h8.75c.2851 0 .5584-.1133.7601-.3147.2014-.2017.3148-.4751.3148-.7603zm0-2.4249h-10.9v-4.575c0-.2851.1132-.5586.3148-.7602.2016-.2014.4749-.3149.7602-.3149h1.0749v1.75h1.35v-1.75h3.9001v1.75h1.35v-1.75h1.075c.2852 0 .5585.1134.7601.3148.2015.2016.3148.4752.3148.7603zm-1.95-3.7001h-1.75v-1.75h-3.5001v1.75h-1.75v-1.75h-.8749c-.2321 0-.4546.0923-.6188.2563-.164.1641-.2562.3867-.2562.6188v4.375h10.5l-.0001-4.375c0-.2321-.0922-.4547-.2562-.6188-.1642-.164-.3866-.2563-.6187-.2563h-.875z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIconInactive);
export default __webpack_public_path__ + "static/media/calendar-icon-inactive.f74cd24b14e0cd6d9df525961dc52bbe.svg";
export { ForwardRef as ReactComponent };